import { render, staticRenderFns } from "./TempoProcesPreparoSemestral.vue?vue&type=template&id=53f4048b&"
import script from "./TempoProcesPreparoSemestral.vue?vue&type=script&lang=js&"
export * from "./TempoProcesPreparoSemestral.vue?vue&type=script&lang=js&"
import style0 from "./TempoProcesPreparoSemestral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports